/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:768px){.forecast-chart-short[_ngcontent-%COMP%]{height:22rem;min-height:22rem;max-height:22rem}}"];
export { styles as styles };
